import { api } from './client'

export function fetchIngestStatus() {
  return api.get('/ingest/status').then((r) => r.data)
}
